import React, { useState, useEffect, useRef } from "react"
import PropTypes from "prop-types"
import { FaTimes } from "react-icons/fa"

import FiveYearRibbon from "../images/ribbons/5year.svg"
import TenYearRibbon from "../images/ribbons/10year.svg"
import FifteenYearRibbon from "../images/ribbons/15year.svg"
import TwentyYearRibbon from "../images/ribbons/20year.svg"
import TwentyfiveYearRibbon from "../images/ribbons/25year.svg"
import ThirtyYearRibbon from "../images/ribbons/30year.svg"
import ThirtyfiveYearRibbon from "../images/ribbons/35year.svg"
import FortyYearRibbon from "../images/ribbons/40year.svg"
import FortyfiveYearRibbon from "../images/ribbons/45year.svg"
import YearBookIcon from "../images/service_award_message_icon.svg"

function EmployeeCard(props) {
  const [showTopFade, setShowTopFade] = useState(false)
  const [showBottomFade, setShowBottomFade] = useState(true)

  const scrollRef = useRef(null)

  const handleScroll = (ref) => {
    setShowTopFade(!(ref.scrollTop === 0))
    setShowBottomFade(!(ref.scrollTop + ref.clientHeight === ref.scrollHeight))
  }

  const onClose = (e) => {
    if (props.onClose) {
      props.onClose(e)
    }
  }

  if (props.person) {
    const person =
      props.person && props.person.value ? props.person.value : props.person

    let ribbon = null
    switch (person.yearsCelebrating) {
      case "5":
        ribbon = FiveYearRibbon
        break
      case "10":
        ribbon = TenYearRibbon
        break
      case "15":
        ribbon = FifteenYearRibbon
        break

      case "20":
        ribbon = TwentyYearRibbon
        break
      case "25":
        ribbon = TwentyfiveYearRibbon
        break
      case "30":
        ribbon = ThirtyYearRibbon
        break
      case "35":
        ribbon = ThirtyfiveYearRibbon
        break
      case "40":
        ribbon = FortyYearRibbon
        break
      case "45":
        ribbon = FortyfiveYearRibbon
        break
      default:
        ribbon = null
    }

    return (
      <div className='ee-card__wrapper'>
        {/* <div className="ee-card__inner-border"></div> */}
        <div className='ee-card__image'>
          <div className='ee-card__image__ribbon'>
            {person.src ? (
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/people/${
                  2020 - 1 - parseInt(person.yearsCelebrating)
                }/${person.src}`}
                alt={person.fullName}
              />
            ) : (
              <img src={ribbon} alt='ribbon' />
            )}
          </div>
          <h1 className='ee-card__image__copy'>Congratulations!</h1>
        </div>
        <div className='ee-card__copy__wrapper'>
        {showTopFade && (
              <div className='ee-card__copy__scroll ee-card__copy__scroll--top'></div>
            )}
            {showBottomFade && (
              <div className='ee-card__copy__scroll ee-card__copy__scroll--bottom'></div>
            )}
          <FaTimes className='ee-card__close' onClick={onClose} />
          <div
            className='ee-card__copy'
            ref={scrollRef}
            onScroll={() => handleScroll(scrollRef.current)}
          >
            
            <h1>{person.fullName}</h1>

            <p>
              {person.dept}
              {Boolean(person.notes) ? ` | ${person.notes}` : null}
            </p>
            <a
              href='https://vision.appreciatehub.com/ui/anniversary/list/8FYVKnwcia-SOhIGxtAkOC5S4ewzi3xiWnKYP8z7fHTScGG_OeqKM_rq_ON3L72Mx2f_-ywHFSCu0dyhrOkyqu3DsASHor9_YGVJdCyQJauUzTwTMfnDnRzt3GhzbaMpJEqYL2MP'
              target='_blank'
              rel='noopener noreferrer'
            >
              <span className='ee-card__copy__yb-link'>
                <img
                  src={YearBookIcon}
                  alt='mail icon'
                  width='100%'
                  className='ee-card__copy__yb-link__icon'
                />
                Leave a message for {person.firstName} in the yearbook
              </span>
            </a>
            <hr />
            {person.contentBio &&
              person.contentBio
                .split("\n\n")
                .map((p, i) => (
                  <p
                    key={`ee-card-${person.firstName}-${person.lastName}-${i}`}
                  >
                    {p}
                  </p>
                ))}
          </div>
        </div>
      </div>
    )
  } else {
    return null
  }
}

EmployeeCard.propTypes = {
  onClose: PropTypes.func,
  person: PropTypes.object.isRequired,
}

export default EmployeeCard
